module.exports = __webpack_public_path__ + "img/logo-sheetlabels.c236ac04.svg";